import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ddw-text-section',
  templateUrl: './text-section.component.html',
  styleUrls: ['./text-section.component.css']
})
export class TextSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
